import NotificationWrapper from "@AppBuilderShared/components/ui/NotificationWrapper";
import {useCustomTheme} from "@AppBuilderShared/hooks/ui/useCustomTheme";
import "@mantine/charts/styles.css";
import {MantineProvider} from "@mantine/core";
import "@mantine/core/styles.css";
import {Notifications} from "@mantine/notifications";
import "@mantine/notifications/styles.css";
import * as ShapeDiverViewerSession from "@shapediver/viewer.session";
import * as ShapeDiverViewerViewport from "@shapediver/viewer.viewport";
import "AppBuilderBase.css";
import React, {useEffect} from "react";
import packagejson from "../package.json";
import { ensureCeruleoRuntimeApi } from "./ceruleo/runtimeApi";
import AppBuilderPageCorsHandler from "./pages/appbuilder/AppBuilderPageCorsHandler";
// Import CORS patches for external domain support
import "./patches/useAppBuilderSettings.patch";

console.log(`ShapeDiver App Builder SDK v${packagejson.version}`);

declare global {
	interface Window {
		SDV: typeof ShapeDiverViewerSession & typeof ShapeDiverViewerViewport;
	}
}

export default function AppBuilderBase() {
	useEffect(() => {
		ensureCeruleoRuntimeApi();
		window.SDV = Object.assign(
			{},
			ShapeDiverViewerSession,
			ShapeDiverViewerViewport,
		);
	}, []);

	const {theme, resolver} = useCustomTheme();

	return (
		<MantineProvider
			defaultColorScheme="auto"
			forceColorScheme={theme.other?.forceColorScheme}
			theme={theme}
			cssVariablesResolver={resolver}
		>
			<Notifications />
			<NotificationWrapper>
				<AppBuilderPageCorsHandler />
			</NotificationWrapper>
		</MantineProvider>
	);
}
